import { createContext } from 'react'
import { User } from 'firebase/auth'

const STAGES = ['idle', 'preview', 'processing', 'finish'] as const
export type Stage = typeof STAGES[number]

export interface MainLayoutContextInterface {
  user: User | null
  language: string
  setLanguage: (newLanguage: string) => void
  deviceId: string
  setDeviceId: (newDeviceId: string) => void
  stage: Stage
  setStage: (newStage: Stage) => void
  processedImageUrl: string | null
  setProcessedImageUrl: (newProcessedImageUrl: string | null) => void
  openLogInModal: () => void
  openSignUpModal: () => void
}

const MainLayoutContext = createContext<MainLayoutContextInterface>(
  {} as MainLayoutContextInterface,
)

export default MainLayoutContext
